// FILE: src/config/contentLinks.js
//
// "Free study guides" links shown in their own row beneath the session-type
// tiles on the ModeSelector (Take a Session) screen. Maps certId → ordered
// list of free PM Pixel articles with a reference icon each. Links open the
// static /articles/ pages in a new tab; app→article navigation is internal,
// so no attribution params (content_id/content_cta flow the OTHER way).

export const CONTENT_LINKS = {
  pmp: [
    {
      id: 'examChanges',
      icon: '\u{1F5DE}\u{FE0F}',
      href: '/articles/pmp-exam-changes-2026/',
      label: '2026 exam changes',
    },
    {
      id: 'caseStudySection',
      icon: '\u{1F5C2}\u{FE0F}',
      href: '/articles/pmp-exam-changes-2026/#the-change-most-providers-are-missing-the-case-study-section',
      label: 'The new case-study section',
    },
    {
      id: 'howHard',
      icon: '\u{1F9ED}',
      href: '/articles/how-hard-is-the-pmp-exam/',
      label: 'How hard is the PMP?',
    },
    {
      id: 'passingScore',
      icon: '\u{1F3AF}',
      href: '/articles/pmp-passing-score/',
      label: 'Passing score, explained',
    },
  ],
  cpmai: [
    {
      id: 'guide',
      icon: '\u{1F4D6}',
      href: '/articles/pmi-cpmai-certification-guide/',
      label: 'Complete PMI-CPMAI guide',
    },
    {
      id: 'samples',
      icon: '\u{1F9EA}',
      href: '/articles/cpmai-practice-questions/',
      label: 'Sample questions',
    },
    {
      id: 'passingScore',
      icon: '\u{1F3AF}',
      href: '/articles/cpmai-passing-score/',
      label: 'CPMAI passing score',
    },
  ],
  // pmi-acp: no published articles yet — the guides row doesn't render.
};

export function listContentLinks(certId) {
  return CONTENT_LINKS[certId] || [];
}
